import Highlight from '@tiptap/extension-highlight';

const HighlightExtension = Highlight;

export default HighlightExtension;
